import './homePageCategories.scss';
import { Link } from 'react-router-dom';

const getSessionValue = (key) => {
  const item = sessionStorage.getItem(key);
  return item ? JSON.parse(item).label : '';
};

const HomePageCategories = () => {
  const defaultCountry = getSessionValue('selectedCountry');
  const defaultRegion = getSessionValue('selectedState');
  const defaultCity = getSessionValue('selectedCity');
  const newUrl = `?country=${defaultCountry}&region=${defaultRegion}&city=${defaultCity}`;

  const categories = [
    {
      name: 'Vehicles and car parts',
      icon: 'icons/vehicle.webp',
      path: 'Vehicles_and_car_parts',
    },
    { name: 'Real estate', icon: 'icons/realty.webp', path: 'Real_Estate' },
    {
      name: 'Mobile phones and tablets',
      icon: 'icons/mobile.webp',
      path: 'Mobile_phones_and_tablets',
    },
    { name: 'Furniture', icon: 'icons/furniture.webp', path: 'Furniture' },
    {
      name: 'Everything for home',
      icon: 'icons/appliances.webp',
      path: 'Everything_for_home',
    },
    {
      name: 'All for kids and moms',
      icon: 'icons/children.webp',
      path: 'All_for_Kids_and_Moms',
    },
    {
      name: 'Electronics',
      icon: 'icons/electronics.webp',
      path: 'Electronics',
    },
    {
      name: 'Services and jobs',
      icon: 'icons/work.webp',
      path: 'Services_and_jobs',
    },
    { name: 'Pet supplies', icon: 'icons/pets.webp', path: 'Pet_supplies' },
    {
      name: 'Beauty and health',
      icon: 'icons/beauty.webp',
      path: 'Beauty_and_health',
    },
    {
      name: "Men's wardrobe",
      icon: 'icons/cloths.webp',
      path: "Men's_Wardrobe",
    },
    {
      name: 'Computer equipment',
      icon: 'icons/PC.webp',
      path: 'Computer_Equipment',
    },
    {
      name: "Women's wardrobe",
      icon: 'icons/wcloths.webp',
      path: "Women's_Wardrobe",
    },
    {
      name: 'Hobbies, sports and tourism',
      icon: 'icons/hobbie.webp',
      path: 'Hobbies,_Sports,_and_Tourism',
    },
    {
      name: 'Repair and construction',
      icon: 'icons/tools.webp',
      path: 'Repair_and_construction',
    },
    {
      name: 'Ready-made business',
      icon: 'icons/business.webp',
      path: 'Ready-made_Business_and_Equipment',
    },
    {
      name: 'Weddings and holidays',
      icon: 'icons/wedding.webp',
      path: 'Weddings_and_holidays',
    },
    {
      name: 'Garden & outdoor',
      icon: 'icons/gardening.webp',
      path: 'Garden_&_Outdoor',
    },
  ];

  return (
    <div className="header__bottom">
      <div className="container">
        <ul className="header__bottom-list">
          {categories.map(({ name, icon, path }) => (
            <li key={path} className="header__bottom-item">
              <Link
                className="header__bottom-link"
                to={`/category/${path}${newUrl}`}
              >
                <div className="header__bottom-container">
                  <p className="header__bottom-title">{name}</p>
                </div>
                <img
                  src={icon}
                  alt={`Category icon for ${name}`}
                  className="header__bottom-img"
                  />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HomePageCategories;
